// src/components/rbac/AdminRoleManager.jsx
import React, { useEffect, useState } from "react";
import { useQuery, useMutation } from "@apollo/client";
import {
  GET_ADMIN_ROLES,
  ADD_ADMIN_ROLE,
  DELETE_ADMIN_ROLE,
  GET_ROLES,
} from "../../graphql/rbac";

export default function AdminRoleManager() {
  const { data, loading, refetch } = useQuery(GET_ADMIN_ROLES, {
    fetchPolicy: "network-only",
    variables: { data: {} },
  });
  const { data: rolesData } = useQuery(GET_ROLES, {
    fetchPolicy: "network-only",
  });

  const [addAdminRole] = useMutation(ADD_ADMIN_ROLE);
  const [deleteAdminRole] = useMutation(DELETE_ADMIN_ROLE);

  const admins = data?.getAdminRoles?.admins || [];
  const roles = rolesData?.getRoles?.roles || [];

  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);

  useEffect(() => {
    if (admins.length && !selectedAdmin) setSelectedAdmin(admins[0]);
  }, [admins]);

  const handleAssign = async () => {
    if (!selectedAdmin || !selectedRole)
      return alert("Select both admin and role");
    const res = await addAdminRole({
      variables: {
        data: { adminId: selectedAdmin.id, roleId: selectedRole.id },
      },
    });
    if (res?.data?.addAdminRole?.status === "SUCCESS") {
      refetch();
    } else {
      alert(res?.data?.addAdminRole?.message || "Failed");
    }
  };

  const handleRemove = async (adminId, roleId) => {
    if (!window.confirm("Remove role from admin?")) return;
    const res = await deleteAdminRole({
      variables: { data: { adminId, roleId } },
    });
    if (res?.data?.deleteAdminRole?.status === "SUCCESS") {
      refetch();
    } else {
      alert(res?.data?.deleteAdminRole?.message || "Failed");
    }
  };

  if (loading) return <p className="text-gray-400">Loading admins...</p>;

  return (
    <div className="text-white">
      <div className="grid grid-cols-3 gap-4 mb-6">
        <select
          className="p-2 bg-[#0c0b0b] rounded"
          value={selectedAdmin?.id || ""}
          onChange={(e) =>
            setSelectedAdmin(admins.find((a) => a.id === e.target.value))
          }
        >
          <option value="">Select Admin</option>
          {admins.map((a) => (
            <option key={a.id} value={a.id}>
              {a.fullName || a.email}
            </option>
          ))}
        </select>

        <select
          className="p-2 bg-[#0c0b0b] rounded"
          value={selectedRole?.id || ""}
          onChange={(e) =>
            setSelectedRole(roles.find((r) => r.id === e.target.value))
          }
        >
          <option value="">Select Role</option>
          {roles.map((r) => (
            <option key={r.id} value={r.id}>
              {r.name}
            </option>
          ))}
        </select>

        <button
          onClick={handleAssign}
          className="bg-[#FBB034] px-4 py-2 rounded font-bold"
        >
          Assign Role
        </button>
      </div>

      <div className="space-y-3">
        {admins.map((admin) => (
          <div
            key={admin.id}
            className="bg-[#0c0b0b] p-3 rounded flex justify-between items-center"
          >
            <div>
              <div className="font-semibold">
                {admin.fullName || admin.email}
              </div>
              <div className="text-sm text-gray-300">
                Roles: {admin.roles.map((r) => r.name).join(", ") || "None"}
              </div>
            </div>
            <div className="flex gap-2">
              {admin.roles.map((r) => (
                <button
                  key={r.id}
                  onClick={() => handleRemove(admin.id, r.id)}
                  className="text-red-500 border border-red-500 px-3 py-1 rounded"
                >
                  Remove {r.name}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
